/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'music-mute': {
    width: 79,
    height: 65,
    viewBox: '0 0 79 65',
    data: '<g _fill="#000" fill-rule="nonzero"><path pid="0" d="M52.98 52.694h.064V13h-.058l-38.474 5.177v31.245a12.545 12.545 0 00-5.024-.53C3.833 49.463-.4 53.484.03 57.903c.43 4.418 5.358 7.553 11.012 7.002 5.655-.552 9.883-4.578 9.453-8.992 0-.074 0-.148-.037-.222h.048V28.59l26.523-3.872v21.701a12.54 12.54 0 00-5.024-.53c-5.654.53-9.887 4.572-9.458 8.991.43 4.419 5.358 7.554 11.013 7.002 5.654-.552 9.888-4.572 9.458-8.991-.01-.048-.032-.106-.037-.197zM75.688 0L68.5 7.188 61.312 0 58 3.313l7.188 7.187L58 17.688 61.313 21l7.187-7.188L75.688 21 79 17.687 71.82 10.5 79 3.312z"/></g>'
  }
})
